import { toCurrency } from './currencyFormat'
import { ValuationRange } from '../@types/valuation'

export const getRangeValuationString = (min?: number, max?: number) => {
  let str = ''
  if (min) {
    str = str.concat(toCurrency(min))
  }
  if (max) {
    str = str.concat(` - ${toCurrency(max)}`)
  }
  return str
}

export const valuationAsString = (value?: number, min?: number, max?: number, prevRange?: ValuationRange) => {
  let str = ''
  if (prevRange) {
    if (value) str = str.concat('ca. ').concat(toCurrency(value))
  } else {
    str = getRangeValuationString(min, max)
  }

  return str.concat(' *')
}
